export default __webpack_public_path__ + "static/media/marketplace.8938164a.svg";